/**
 * Extend Default Settings
 * Extends the default settings of an object.
 * Default properies will be overwritten if the same key matches.
 * This is a shallow extension only useful for simple (single level) objects.
 * @param {object} defaults
 * @param {object} settings
 */
export const extendDefaultSettings = (defaults, settings) => {
  for (var key in settings) {
    if (Object.prototype.hasOwnProperty.call(settings, key)) {
      defaults[key] = settings[key]
    }
  }

  return defaults
}

/**
 * Has Callback
 * Checks if object is a valid function.
 * @param {object} styleProperty
 * @return {boolean}
 */
export const hasCallback = (callback) => {
  return callback && typeof callback === "function"
}

/**
 * Is Email
 * Checks if string is a valid email.
 * @param {string} email
 * @return {boolean}
 */
export const isEmail = (email) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}

/**
 * Is Phone
 * Checks if string is a valid tel.
 * @param {string} tel
 * @return {boolean}
 */
export const isTel = (tel) => {
  return /^tel:/.test(tel)
}

/**
 * Capitalise First Letter
 * @param {string} text
 * @return {mixed}
 */
export const capitaliseFirstLetter = (text) => {
  if (text) {
    const words = text.split(" ")

    for (let i = 0; i < words.length; i++) {
      words[i] = words[i][0].toUpperCase() + words[i].substr(1)
    }

    return words.join(" ")
  }

  return null
}

/**
 * Track Event
 * @param {string} category
 * @param {string} action
 * @param {string} label
 * @return {void}
 */
export const trackEvent = (category, action, label) => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", action, {
      event_category: category,
      event_label: label,
    })
  }
}

/**
 * Track Page View
 * @param {string} title
 * @param {string} location
 * @param {string} path
 * @return {void}
 */
export const trackPageView = (title, location, path) => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", "page_view", {
      page_title: title,
      page_location: location,
      page_path: path,
    })
  }
}

/**
 * Track FB Event
 * @param {string} name
 * @return {void}
 */
export const trackFbEvent = (name) => {
  if (typeof window !== "undefined" && window.fbq) {
    window.fbq("trackCustom", name)
  }
}

/**
 * Track FB Event
 * @return {void}
 * @param signupVariable
 */
export const setupTrackEmbeddedFormEvent = (signupVariable=null) => {
  if (window.ecPF != null) {


    const ecPFSignupVariable = signupVariable || 'yes_i_would_like_to_receive_news_updates_and_offers_from_london_city_airport_ltd_find_out_about_your_rights_and_choices_and_how_we_use_your_information_in_london_city_airports_privacy_policy_'
    window.ecPF.onComplete(function(data) {
      const signedUp = data.form[ecPFSignupVariable]

      // optionally trigger the success

      console.log('SIGNEDUP', signedUp)
      if(signedUp) {
        window.dataLayer.push({ event: 'subscribe_contact', contact_list: 'Newsletter sign up' })
      }
    })
  }
}

export const trackEmailEvent = (event, e) => {
  const el = e.target
  const action = capitaliseFirstLetter(event)

  if (el.matches('a') && isEmail(el.getAttribute('href'))) {
    window.dataLayer.push({ event: 'enquire_email_view', enquire_email: el.textContent, action })
  }
}

export const trackTelEvent = (event, e) => {
  const el = e.target
  const action = capitaliseFirstLetter(event)

  if (el.matches('a') && isTel(el.getAttribute('href'))) {
    window.dataLayer.push({ event: 'enquire_phone_view', enquire_phone: el.textContent, action })
  }
}

/**
 * URL Matches Keyword
 * Checks that a URL contains a particular keyword.
 * Optionally filter by different location types see
 * https://developer.mozilla.org/en-US/docs/Web/API/Location#properties
 * @param {string} regex
 * @param {string} type
 * @returns {boolean}
 */
export const urlMatchesKeyword = (regex, type = "href") => {
  if (typeof window !== "undefined") {
    const href = window.location[type]
    return href.match(regex)
  }

  return false
}

/**
 * Debounce
 * @param {func} func
 * @param {number} timeout
 * @return {void}
 */
export const debounce = (func, timeout = 300) => {
  let timer
  return (...args) => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      func.apply(this, args)
    }, timeout)
  }
}
